
import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import CartItemList from '@/components/cart/CartItemList.vue';
import CartOrderList from '@/components/cart/CartOrderList.vue';
import CartPricing from '@/components/cart/CartPricing.vue';

const namespace: string = 'cart';

@Component<CheckoutReviewOrderDetails>({
	components: {
		CartItemList,
		CartOrderList,
		CartPricing
	}
})
export default class CheckoutReviewOrderDetails extends Vue {
	@Getter('getItems', { namespace }) private items!: OrderItem[];
	@Getter('getRotationalMenuOrders', { namespace }) private rotationalMenuOrders!: RotationalMenuOrder[];
	@Getter('getTaxInfo', { namespace }) private taxInfo!: TaxInfo[];
	@Getter('getSubtotal', { namespace }) private subtotal!: string;
	@Getter('getSubsidyDiscountAmount', { namespace }) private subsidyDiscountAmount!: string;
	@Getter('getPromoDiscount', { namespace }) private promoDiscount!: string;
	@Getter('getMemberDiscount', { namespace }) private memberDiscount!: string;
	@Getter('getServiceCharge', { namespace }) private serviceCharge!: string | null;
	@Getter('getDeliveryCharge', { namespace }) private deliveryCharge!: string | null;
	@Getter('getTaxes', { namespace }) private taxes!: string;
	@Getter('getTotal', { namespace }) private total!: string;
	@Getter('getTotalWithoutTaxes', { namespace }) private totalWithoutTaxes!: string | undefined;
	@Getter('getTip', { namespace }) private tip!: string;
	@Getter('getVoucherAmount', { namespace }) private voucherAmount!: string;
	@Getter('getTotalWithTip', { namespace }) private totalWithTip!: string;
	@Getter('getCreditsApplied', { namespace }) private creditsApplied!: CreditsCosts;
	@Getter('isK12Location', { namespace: 'restaurant' }) private isK12Location!: boolean;

	/**
	 * Send event to the parent to switch to the respective
	 * screen depending on what change button was clicked
	 * (IE: payment info)
	 *
	 * @param {number} index - screen index
	 * @return {void}
	 */
	private switchTo(index: number): void {
		this.$emit('switchTo', index);
	}
}
